<template>
    <div :class="['agent-headshot', keyClass]">
        <img-box class="agent-img" :src="targetSrc" :alt="alt || 'agent'" :dir="dir" :size="size" :errorImg="errorImg" @click="imgClick">
            <slot name="inner"></slot>
        </img-box>
        <slot></slot>
    </div>
</template>
<script>
const errorImgs = {
    OneByOne: 'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png',
    ThreeByFour: 'https://cdn.chime.me/image/fs/sitebuild/2025117/5/original_26507295-374f-48e2-b93d-e439771031c7.png',
    FiveByThree: 'https://cdn.chime.me/image/fs/sitebuild/2025117/5/original_e82ffebe-fc7f-412a-92a1-d6891ac74094.png'
}
export default {
    i18next: {
        ns: 'common'
    },
    props: {
        headshots: {
            type: Object,
            default: () => ({})
        },
        initImage: {
            type: String,
            default: ''
        },
        alt: {
            type: String,
            default: ''
        },
        dir: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default: 0
        },
        useParentDom: {
            type: Boolean,
            default: false
        },
        keyClass: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            ratioList: [
                { type: 'OneByOne', ratio: [1, 1], value: 1 }, // width : height
                { type: 'ThreeByFour', ratio: [3, 4], value: 0.75 },
                { type: 'FiveByThree', ratio: [5, 3], value: 1.66 }
            ],
            ratioType: '',
            targetSrc: '',
            resizeObserver: null
        }
    },
    computed: {
        errorImg() {
            return errorImgs[this.ratioType] || errorImgs.OneByOne;
        }
    },
    watch: {
        headshots() {
            this.$nextTick(() => {
                let dom = this.$el;
                if (dom) {
                    this.calcRatioType(dom);
                }
            })
        },
        initImage() {
            this.$nextTick(() => {
                let dom = this.$el;
                if (dom) {
                    this.calcRatioType(dom);
                }
            })
        },
    },
    mounted() {
        let dom = this.$el;
        if (dom) {
            this.resizeObserver = new ResizeObserver(entries => {
                this.calcRatioType(dom);
            });
            try {
                this.resizeObserver.observe(this.$el);
                window.addEventListener('resize', this.calcRatioType(this.$el), false);
            } catch (e) {}
        }
    },
    unmounted() {
        try {
            this.resizeObserver && this.resizeObserver.unobserve(this.$el);
            window.removeEventListener('resize', this.calcRatioType(this.$el));
        } catch (e) {}
    },
    methods: {
        imgClick() {
            this.$emit('imgClick')
        },
        calcRatioType(container) {
            let conW = container.offsetWidth;
            let conH = container.offsetHeight;
            if (this.useParentDom) {
                const parentDom = container.parentNode;
                const parentWidth = parentDom.offsetWidth;
                const parentHeight = parentDom.offsetHeight;
                conW = parentWidth;
                conH = parentHeight;
            } 
            if (conW && conH) {
                const conRatio = (conW / conH).toFixed(2);
                const targetItem = this.findClosestRatio(this.ratioList, conRatio);
                this.ratioType = targetItem.type || ''
            } else {
                this.ratioType = ''
            }
            this.getTargetImage()
        },
        getTargetImage() {
            if (this.ratioType) {
                if (this.headshots?.['photo' + this.ratioType]) {
                    this.targetSrc = this.headshots?.['photo' + this.ratioType]
                } else {
                    this.targetSrc = this.headshots?.['photoOneByOne'] || this.headshots?.['photoThreeByFour'] || this.headshots?.['photoFiveByThree'] || this.initImage
                }
            } else {
                this.targetSrc = this.initImage
            }
        },
        findClosestRatio(arr, target) {
            return arr.reduce(function(prev, curr) {
                return Math.abs(target - curr.value) < Math.abs(target - prev.value) ? curr : prev;
            });
        },
    }
}
</script>
<style lang="scss">
.agent-headshot {
    width: 100%;
    height: 100%;
    .agent-img {
        width: 100%;
        height: 100%;
    }
}
</style>
